import estilos from './Rodape.module.css';

export default function Rodape() {
  return (
    <footer className={estilos.rodape}>
      <div className={estilos.wrapper}>
        <div>
          <p className={estilos.brand}>SkySense</p>
          <p className={estilos.text}>
            Planeje viagens mais inteligentes com ofertas reunidas em um só lugar.
          </p>
        </div>
        <div className={estilos.links}>
          <p className={estilos.title}>Contato</p>
          <a href="mailto:contato@skysense.com">contato@skysense.com</a>
          <a href="tel:+5511999999999">+55 (11) 99999-9999</a>
        </div>
      </div>
    </footer>
  );
}
